import Illustration from '@/components/Illustration'

const NAME_MAP: Record<string, string> = {
  'kids-joy': 'kids',
  network: 'books',
}

interface SectionIllustrationProps {
  name?: string;
  className?: string;
}

export default function SectionIllustration({ name, className = '' }: SectionIllustrationProps) {
  const resolved = (name ? NAME_MAP[name] : undefined) || name || 'leaf'
  return <Illustration name={resolved} animate className={className} />
}
